import { useState } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { ethers } from "ethers";
import { toast } from "react-toastify";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AddPaidWalletDialog(props) {
  const handleClose = () => {
    props.setOpen(false);
  };

  const handleCloseAddWallet = () => {
    if (!props.userAuthWallet) {
      toast.error("First connect the wallet!");
      return;
    }

    if (!walletAddress || !ethers.utils.isAddress(walletAddress)) {
      toast.error("Please enter valid wallet address!");
      return;
    }

    Axios.post(process.env.REACT_APP_CRUD_SRV + "/wallet/add", {
      walletAddress,
      walletName,
      auth: props.userAuthWallet,
      cs: sha256(
        walletAddress + props.userAuthWallet + process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      if (r.data?.status == 200) {
        console.log("Wallet " + walletAddress + " has been added.");
        props.getWallets();
      } else
        toast.error("Wallet add error. Please wait for some time and try again.");
    });

    props.setOpen(false);
  };

  const [walletAddress, setWalletAddress] = useState("");

  function handleWalletAddressChange(evt) {
    // console.log(evt.target.value);
    setWalletAddress(evt.target.value);
  }

  const [walletName, setWalletName] = useState("");

  function handleWalletNameChange(evt) {
    // console.log(evt.target.value);
    setWalletName(evt.target.value);
  }

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open form dialog
      </Button> */}
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle>Add Additional Wallet</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To add additional wallet, please enter wallet address bellow. For
            convenience, you can also add a wallet name, such as "Main wallet"
            or "Boris's wallet" or "Whale wallet", etc.
          </DialogContentText>
          {/* <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
          /> */}
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Wallet Address"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleWalletAddressChange}
          />
          <TextField
            margin="dense"
            id="name"
            label="Wallet Name (Optional)"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleWalletNameChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleCloseAddWallet}>Add Additional Wallet</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
